<template>
    <div>
        <b-card class="mb-3">
            <b-row>
                <b-col lg="12" xl="6">
                    <b-input-group size="sm">
                        <b-form-select :options="typeOptions"
                                       v-model="component.type"
                                       disabled
                                       tabindex="-1"
                                       :state="component.type && component.type.length ? null : false">
                            <template #first>
                                <b-form-select-option :value="null">Type</b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-input-group-append>
                            <b-input-group size="sm" prepend="Count">
                                <b-input v-model.number="component.count"
                                         type="number"
                                         style="width: 4rem;"
                                         min="0">
                                </b-input>
                            </b-input-group>
                        </b-input-group-append>

                        <b-input-group-append>
                    <b-input-group size="sm" prepend="Location">
                                <b-input-group-append v-if="defaultLocation.length">
                                    <b-button size="sm" :id="'defaultLocation-' + index" variant="outline-primary" tabindex="-1" @click="useDefaultLocation()">
                                        <b-icon-forward></b-icon-forward>
                                    </b-button>

                                    <b-tooltip :target="'defaultLocation-' + index" triggers="hover">
                                        {{ defaultLocation }}
                                    </b-tooltip>
                                </b-input-group-append>

                                <b-input v-model="component.location"
                                         :state="component.location && component.location.length > 1 ? null : false"
                                         style="width: 5rem;"></b-input>

                                <b-input-group-append
                                    v-if="component.type === 'inactive' && firstActiveLocation"
                                >
                                    <b-button
                                        size="sm"
                                        :id="'copyActiveLocation-' + index"
                                        variant="outline-primary"
                                        tabindex="-1"
                                        @click="useFirstActiveLocation()"
                                    >
                                        <b-icon-arrow-down></b-icon-arrow-down>
                                    </b-button>

                                    <b-tooltip :target="'copyActiveLocation-' + index" triggers="hover">
                                        Use active location ({{ firstActiveLocation }})
                                    </b-tooltip>
                                </b-input-group-append>
                            </b-input-group>
                        </b-input-group-append>

                        <b-input-group-append v-if="component.username">
                            <b-button size="sm" :id="'listingUser-' + index" variant="outline-info" tabindex="-1">
                                <b-icon-person></b-icon-person>
                            </b-button>

                            <b-tooltip :target="'listingUser-' + index" triggers="hover">
                                {{ component.username }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append v-if="component.date">
                            <b-button size="sm" :id="'listingDate-' + index" variant="outline-info" tabindex="-1">
                                <b-icon-calendar4-event></b-icon-calendar4-event>
                            </b-button>

                            <b-tooltip :target="'listingDate-' + index" triggers="hover">
                                {{ moment(component.date).format('M/D/YYYY h:mma') }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append>
                            <b-button size="sm" variant="outline-primary" @click="printTag(index)" tabindex="-1" :disabled="!itemId">
                                <b-icon-tag></b-icon-tag>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>

                    <b-input-group size="sm">
                        <b-input-group-append v-if="component.type === 'active'">
                            <b-button size="sm" :id="'listingPrice-' + index" variant="outline-info" tabindex="-1">
                                $
                            </b-button>

                            <b-tooltip data-container="body" variant="dark" :target="'listingPrice-' + index" triggers="hover">
                                    <table v-if="priceHistory && priceHistory.length > 0">
                                        <tr style="color: white;" v-for="(val, index) in priceHistory" :key="index">
                                            <td class="pr-3" align="left">{{ val.username || '(none)' }}</td>
                                            <td class="pr-3" align="left">{{ formatDate(val.date) }}</td>
                                            <td align="left">${{ val.price }}</td>
                                        </tr>
                                    </table>
                                    <span v-else>No history</span>
                            </b-tooltip>
                            <!-- <b-input-group size="sm" prepend="$"> -->
                                <b-input v-model.number="component.price"
                                         size="sm"
                                         type="number"
                                         min="4"
                                         :state="component.price && component.price > 3 ? null : false"
                                         style="width: 5rem;"></b-input>
                            <!-- </b-input-group> -->

                        </b-input-group-append>

                        <b-input-group-append v-if="defaultSource.length">
                            <b-button size="sm" :id="'defaultSource-' + index" variant="outline-primary" tabindex="-1" @click="useDefaultSource()">
                                <b-icon-forward></b-icon-forward>
                            </b-button>

                            <b-tooltip :target="'defaultSource-' + index" triggers="hover">
                                {{ defaultSource }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input v-model="component.source"
                                 placeholder="Source"
                                 tabindex="-1"
                                 :state="component.type === 'active' && (!component.source || component.source.length === 0) ? false : null">
                            ></b-input>

                        <b-input v-model="component.consigner" placeholder="Consigner" tabindex="-1"></b-input>
                        <b-checkbox v-if="component.type === 'active'" class="pt-1 ml-3" v-model="component.offsite" switch>Off-site</b-checkbox>

                        <!--<b-form-select :options="sourceOptions" v-model="component.source">-->
                            <!--<template #first v-if="component.source === undefined">-->
                                <!--<b-form-select-option :value="undefined" disabled>Source</b-form-select-option>-->
                            <!--</template>-->

                            <!--<template #first v-else-if="component.source === ''">-->
                                <!--<b-form-select-option :value="''" disabled>Source</b-form-select-option>-->
                            <!--</template>-->
                        <!--</b-form-select>-->

                        <!--<b-form-select :options="consignerOptions" v-model="component.consigner">-->
                            <!--<template #first v-if="component.consigner === undefined">-->
                                <!--<b-form-select-option :value="undefined" disabled>Consigner</b-form-select-option>-->
                            <!--</template>-->

                            <!--<template #first v-else-if="component.consigner === ''">-->
                                <!--<b-form-select-option :value="''" disabled>Consigner</b-form-select-option>-->
                            <!--</template>-->
                        <!--</b-form-select>-->
                    </b-input-group>

                    <b-row>
                        <b-col v-if="component.type === 'active'">
                            <b-form-tags v-model="component.attributes"
                                         size="sm"
                                         placeholder=""
                                         no-outer-focus
                                         separator=","
                                         remove-on-delete>
                                <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">
                                    <b-input-group aria-controls="my-custom-tags-list" size="sm">
                                        <drop @drop="dropAttribute($event)" style="width: 100%">
                                            <input v-bind="inputAttrs"
                                                   v-on="inputHandlers"
                                                   placeholder="Attributes"
                                                   class="form-control drop-input">
                                        </drop>
                                    </b-input-group>
                                    <ul class="list-unstyled d-inline-flex flex-wrap mb-0">
                                        <b-card v-for="tag in tags" :key="tag" size="sm"
                                                class="mt-1 mr-1"
                                                body-class="py-0 pr-2">
                                            <span>{{ tag }}</span>
                                            <b-button variant="link" class="pt-1 pb-1 text-secondary" @click="removeTag(tag)" tabindex="-1">
                                                <b-icon-x-square></b-icon-x-square>
                                            </b-button>
                                        </b-card>
                                    </ul>
                                </template>
                            </b-form-tags>
                        </b-col>

                        <b-col v-if="component.type === 'active'">
                            <b-form-tags v-model="component.additions"
                                         size="sm"
                                         placeholder=""
                                         no-outer-focus
                                         separator=","
                                         remove-on-delete>
                                <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">
                                    <b-input-group aria-controls="my-custom-tags-list" size="sm">
                                        <drop @drop="dropAddition($event)" style="width: 100%">
                                            <input v-bind="inputAttrs"
                                                   v-on="inputHandlers"
                                                   placeholder="Additions"
                                                   class="form-control drop-input">
                                        </drop>
                                    </b-input-group>
                                    <ul class="list-unstyled d-inline-flex flex-wrap mb-0">
                                        <b-card v-for="tag in tags" :key="tag" size="sm"
                                                class="mt-1 mr-1"
                                                body-class="py-0 pr-2">
                                            <span>{{ tag }}</span>
                                            <b-button variant="link" class="pt-1 pb-1 text-secondary" @click="removeTag(tag)" tabindex="-1">
                                                <b-icon-x-square></b-icon-x-square>
                                            </b-button>
                                        </b-card>
                                    </ul>
                                </template>
                            </b-form-tags>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col v-if="component.type === 'active'" sm="4">
                    <b-row>
                        <b-col>
                            <h6 class="pt-1 text-secondary">Condition</h6>
                        </b-col>

                        <b-col align="right">
                            <b-button @click="addCondition" variant="outline-secondary" size="sm" tabindex="-1">
                                <b-icon-plus></b-icon-plus>
                            </b-button>
                        </b-col>
                    </b-row>

                    <div v-for="(condition, index) in component.condition" v-bind:key="index" class="mb-3">
                        <condition 
                            :fillSubject="component.condition.length < 2 && !component.condition[0].grade" 
                            :mediaType="mediaType" 
                            :mediaSpeed="mediaSpeed"
                            :mediaSize="mediaSize"
                            :condition="condition"
                            @updateCondition="updateCondition(index, $event)" 
                            @removeCondition="removeCondition(index)" 
                            @removeTag="removeTag(index, $event)" 
                            @dropConditionNote="dropConditionNote(index, $event)" />
                    </div>
                </b-col>

                <b-col v-if="component.type === 'active' && listing.images.length">
                    <b-row>
                        <b-col>
                            <b-link @click="showImages(listing.images)">
                                <b-img-lazy :src="imageUrl(listing.images[0].url)"
                                       :title="listing.images[0].url"
                                       thumbnail
                                       fluid
                                       width="125"></b-img-lazy>
                            </b-link>
                        </b-col>
                        <b-col>
                            <b-button size="sm" variant="outline-secondary" @click="removeImages(listing.images)" tabindex="-1">
                                <b-icon-x></b-icon-x>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col v-if="component.type === 'active' && listing.soundclips.length">
                    <b-row>
                        <b-col>
                            <span v-for="(clip, index) in listing.soundclips" :key="index">
                                <audio controls>
                                    <source :src="soundclipUrl(clip.url)"
                                            type="audio/mpeg">
                                </audio>
                                <b-button size="sm" variant="outline-secondary" @click="removeClip(index)" tabindex="-1" style="vertical-align: top; margin-top: 0.75em;">
                                    <b-icon-x></b-icon-x>
                                </b-button>
                            </span>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row v-if="index !== 0 && index !== 1 && !listing._id">    
                <b-col class="text-right">                  
                <b-button size="sm" variant="outline-danger" @click="removeListing(index)" tabindex="-1">
                    Delete Listing
                </b-button>
            </b-col>  
            </b-row>
        </b-card>



            <!--<b-col xl="4" lg="6">-->
                <!--<span v-for="(image, index) in listing.images" v-bind:key="index" class="ml-3">-->
                    <!--<b-img :src="imageUrl(image.url)" style="width: 35%" :title="image.url" />-->
                <!--</span>-->

                <!--<p v-for="(soundclip, index) in listing.soundclips" v-bind:key="index">-->
                    <!--{{ soundclip.url }}-->
                <!--</p>-->
            <!--</b-col>-->

        <!--<div v-if="listing.username || listing.date">-->
            <!--<b-icon-info-circle-fill class="text-secondary" :id="listing._id"></b-icon-info-circle-fill>-->
            <!--<b-tooltip :target="listing._id" triggers="hover">-->
                <!--{{ listing.username }}-->
                <!--{{ formatDate(listing.date) }}-->
            <!--</b-tooltip>-->
        <!--</div>-->

        <div :id="'listingTag-' + barcodeData" class="barcode-container">
            <barcode :data="barcodeData"
                     :text="barcodeData"
                     :location="component.location"
                     :type="component.type"
                     :source="component.source">
            </barcode>
        </div>
    </div>
</template>

<script>
    import objectMixin from "../../mixins/object";
    import Barcode from "../Barcode";
    import Condition from "./Condition";
    import moment from "moment";
    import inventoryApi from "../../api/inventory";

    // import printJS from "print-js";

    export default {
        name: "ItemListing",
        props: [ 'listing', 'index', 'itemId', 'mediaType', 'item', 'mediaSpeed', 'mediaSize', 'allListings' ],
        mixins: [ objectMixin, inventoryApi],
        components: { Barcode, Condition },
        async created() {
            await this.resetComponent();
            console.log('ItemListing created with speed:', this.speed);
        },
        data() {
            return {
                emptyCondition: {
                    subject: null,
                    grade: null,
                    notes: [],
                },
                typeOptions: [
                    { text: 'Active', value: 'active' },
                    { text: 'Inactive', value: 'inactive' },
                    { text: 'Cover', value: 'cover' },
                    { text: 'Disc', value: 'disc' },
                ],
                sourceOptions: [],
                consignerOptions: [],
                defaultLocation: null,
                defaultSource: null,
                defaultOffsite: false,
                priceHistory: [],
            }
        },
        methods: {
            async getPriceHistory() {
                const history = await this.getListingFieldHistory(this.component._id, 'price');
                return history;
            },

            async resetComponent() {
                this.clone(this.listing);
                this.defaultSource = localStorage.getItem('inventorySource') || '';
                this.defaultLocation = localStorage.getItem('inventoryLocation') || '';
                this.defaultOffsite = localStorage.getItem('inventoryOffsite') || false;
                this.priceHistory = await this.getPriceHistory();
            },
            useDefaultSource() {
                this.$set(this.component, 'source', this.defaultSource);
            },
            useDefaultLocation() {
                this.$set(this.component, 'location', this.defaultLocation);
            },
            useFirstActiveLocation() {
                if (this.firstActiveLocation) {
                    this.$set(this.component, 'location', this.firstActiveLocation);
                }
            },

            showImages(images) {
                this.$emit('showImages', images);
            },
            addCondition() {
                const newArray = [...this.component.condition];
                const empty = {...this.emptyCondition}
                newArray.push(empty);
                this.$set(this.component, 'condition', newArray);
            },
            removeCondition(index) {
                // this.$delete(this.component.condition, index);

                this.component.condition.splice(index, 1);
                // this.listing.condition.splice(index, 1);
            },
            updateCondition(index, condition) {
                this.$set(this.component.condition, index, condition);
            },
            // changeGrade(index, grade) {
            //     if (grade) {
            //         this.$nextTick(() => {
            //             let ref = 'subject-' + index;

            //             this.$refs[ref][0].$el.focus();
            //         });
            //     }
            // },
            dropConditionNote(index, note) {
                this.component.condition[index].notes.push(note);
                this.handleNoteDrop(note);
            },
            removeImages() {
                this.$set(this.listing, 'images', []);
                this.$set(this.component, 'images', []);
            },
            removeClip(index) {
                this.listing.soundclips.splice(index, 1);
                this.component.soundclips.splice(index, 1);
            },
            handleNoteDrop(note) {
                this.$emit('dropNote', note);
            },

            dropAttribute(note) {
                this.component.attributes.push(note);
                this.handleNoteDrop(note);
            },
            dropAddition(note) {
                this.component.additions.push(note);
                this.handleNoteDrop(note);
            },
            imageUrl(url) {
                return `${process.env.VUE_APP_IMAGES_URL}${url}`;
            },
            soundclipUrl(url) {
                return `${process.env.VUE_APP_CLIPS_URL}${url}`;
            },
            formatDate(date) {
                if (date) {
                    return moment(date).format('M/D/YYYY h:mma');
                }
            },
            printTag() {
                const printOptions = {
                    name: '_blank',
                    specs: [
                        // 'fullscreen=yes',
                        // 'titlebar=yes',
                        // 'scrollbars=yes'
                    ],
                    styles: [
                        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                        'https://unpkg.com/kidlat-css/css/kidlat.css',
                        './assets/barcodePrint.css'
                    ]
                };
                this.$htmlToPaper('listingTag-' + this.barcodeData, printOptions, () => {
                });
            },
            removeListing() {
                this.$emit('removeListing', this.index);
            },

        },
        computed: {
            barcodeData() {
                return this.itemId + '_' + (this.index + 1);
            },
            listingCount() {
                return this.component.count;
            },
            firstActiveLocation() {
                if (!this.allListings || !Array.isArray(this.allListings)) {
                    return null;
                }

                const activeListing = this.allListings.find(
                    (listing) => listing && listing.type === 'active' && listing.location
                );

                return activeListing && activeListing.location
                    ? activeListing.location
                    : null;
            },
        },
        watch: {
            listingCount(newValue, oldValue) {
                if (parseInt(oldValue) === 0 && parseInt(newValue) > 0 && this.component.type === 'active') {
                    this.$set(this.component, 'offsite', this.defaultOffsite);
                }
            },
            speed(newValue, oldValue) {
                console.log('ItemListing speed changed:', { oldValue, newValue });
            }
        }
        
    }
</script>

<style scoped>
    .card-body {
        padding: 0.5rem;
    }

    .drop-input {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
    }

    .barcode-container {
        position: absolute;
        top: -9999px;
        left: -9999px;
    }
</style>

<style>
   .tooltip-inner {
        max-width: 100% !important;
    }
</style>